import React from "react";
import SEO from "../components/SEO";
import Header from "../components/Header";
import Footer from "../components/Footer";

import AboutBanner from "../components/AboutBanner";
import AboutContent from "../components/AboutContent";

const About = () => {
  return (
    <>
      <SEO page="about" />
      <Header />
      <AboutBanner />
      <AboutContent />
      <Footer />
    </>
  );
};

export default About;